<template>
  <div id="children_order">
    <div>
      <div align="right" class="lv3Text r1">
        <router-link to="/user/recycle">
          <i class="el-icon-delete"></i>订单回收站
        </router-link>
      </div>
      <el-tabs type="border-card" v-model="tab" @tab-click="handleClick">
        <el-tab-pane label="全部订单" name="all">
          <!-- v-if="tableData.length!=0" -->
          <div>
            <el-row :gutter="20">
              <el-col :span="7">
                <div class="grid-content bg-purple">
                  <el-input size="mini" placeholder="搜索订购人" v-model="name">
                    <template slot="append">
                      <div style="cursor: pointer" @click="search()">搜索</div>
                    </template>
                  </el-input>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="grid-content bg-purple">
                  <el-select size="mini" v-model="value" placeholder="请选择状态" @change="selectChange">
                    <el-option
                      v-for="item in options"
                      :key="item.vlaue"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </div>
              </el-col>
            </el-row>
            <el-row style="margin-top:-12px">
              <template>
                <el-table
                  v-loading="loading"
                  cell-class-name="tab_class"
                  :header-cell-style="{
                      'background' : 'rgba(245,250,249,1)'
                    }"
                  :data="tableData"
                  border
                  style="width: 100%;margin-top:30px"
                  :span-method="arraySpanMethod"
                >
                  <el-table-column width="180" prop="orderCode" align="center" label="订单号"></el-table-column>
                  <el-table-column align="center" label="商品名称">
                    <template slot-scope="scope">
                      <el-table
                        :data="JSON.parse(tableData[scope.$index].product_list)"
                        :show-header="false"
                        style="width: 100%"
                      >
                        <el-table-column align="center" show-overflow-tooltip prop="title"></el-table-column>
                        <el-table-column align="center" prop="brand"></el-table-column>
                        <el-table-column align="center" prop="item_no"></el-table-column>
                        <el-table-column align="center" prop="scope.children_remark">
                          <el-tooltip effect="light" placement="top-start">
                            <div slot="content" style="width:189px;line-height:20px">
                              <div>
                                <span>订货人:</span>
                                <span>{{scope.row.address.split(';')[1]}}</span>
                              </div>
                              <div>
                                <span>联系方式:</span>
                                <span>{{scope.row.address.split(';')[0]}}</span>
                              </div>
                              <div>
                                <span>收货地址:</span>
                                <span>{{scope.row.address.split(';')[2]}}</span>
                                <span>{{scope.row.address.split(';')[3]}}</span>
                                <span>{{scope.row.address.split(';')[4]}}</span>
                                <span>{{scope.row.address.split(';')[5]}}</span>
                              </div>
                            </div>
                            <span>{{scope.row.children_remark!=''?scope.row.children_remark:scope.row.nickname}}</span>
                          </el-tooltip>
                        </el-table-column>
                        <el-table-column align="center" prop="price"></el-table-column>
                        <el-table-column align="center" prop="number"></el-table-column>
                        <el-table-column
                          align="center"
                          show-overflow-tooltip
                        >{{new Date(parseInt(scope.row.create_time) * 1000).toLocaleString().replace(/:\d{1,2}$/,'') }}</el-table-column>
                      </el-table>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="品牌"></el-table-column>
                  <el-table-column align="center" label="货号"></el-table-column>
                  <el-table-column align="center" label="订购人"></el-table-column>
                  <el-table-column align="center" label="单价"></el-table-column>
                  <el-table-column align="center" label="数量"></el-table-column>
                  <el-table-column align="center" label="日期"></el-table-column>
                  <el-table-column align="center" label="订单状态">
                    <template slot-scope="scope">{{scope.row.status1}}</template>
                  </el-table-column>
                </el-table>
              </template>
              <div class="export">
                <span class="export1" @click="export_refuse">导出列表</span>
              </div>
              <div v-if="total>10">
                <el-pagination
                  background
                  layout="prev, pager, next"
                  :total="total"
                  :page-size="10"
                  @current-change="setPage"
                  style="text-align:center"
                  hide-on-single-page
                ></el-pagination>
              </div>
            </el-row>
          </div>
        
        </el-tab-pane>
        <el-tab-pane label="待付款" name="0">
          <div>
            <el-row :gutter="20">
              <el-col :span="7">
                <div class="grid-content bg-purple">
                  <el-input size="mini" placeholder="搜索订购人" v-model="name">
                    <template slot="append">
                      <div style="cursor: pointer" @click="search()">搜索</div>
                    </template>
                  </el-input>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="grid-content bg-purple">
                  <el-select size="mini" v-model="value" placeholder="请选择状态" @change="selectChange">
                    <el-option
                      v-for="item in options"
                      :key="item.vlaue"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </div>
              </el-col>
            </el-row>
            <el-row style="margin-top:-12px">
              <template>
                <el-table
                  v-loading="loading"
                  cell-class-name="tab_class"
                  :header-cell-style="{
                      'background' : 'rgba(245,250,249,1)'
                    }"
                  :data="tableData"
                  border
                  style="width: 100%;margin-top:30px"
                  :span-method="arraySpanMethod"
                >
                  <el-table-column width="180" prop="orderCode" align="center" label="订单号"></el-table-column>
                  <el-table-column align="center" label="商品名称">
                    <template slot-scope="scope">
                      <el-table
                        :data="JSON.parse(tableData[scope.$index].product_list)"
                        :show-header="false"
                        style="width: 100%"
                      >
                        <el-table-column align="center" show-overflow-tooltip prop="title"></el-table-column>
                        <el-table-column align="center" prop="brand"></el-table-column>
                        <el-table-column align="center" prop="item_no"></el-table-column>
                        <el-table-column align="center" prop="scope.children_remark">
                          <el-tooltip effect="light" placement="top-start">
                            <div slot="content" style="width:189px;line-height:20px">
                              <div>
                                <span>订货人:</span>
                                <span>{{scope.row.address.split(';')[1]}}</span>
                              </div>
                              <div>
                                <span>联系方式:</span>
                                <span>{{scope.row.address.split(';')[0]}}</span>
                              </div>
                              <div>
                                <span>收货地址:</span>
                                <span>{{scope.row.address.split(';')[2]}}</span>
                                <span>{{scope.row.address.split(';')[3]}}</span>
                                <span>{{scope.row.address.split(';')[4]}}</span>
                                <span>{{scope.row.address.split(';')[5]}}</span>
                              </div>
                            </div>
                            <span>{{scope.row.children_remark!=''?scope.row.children_remark:scope.row.nickname}}</span>
                          </el-tooltip>
                        </el-table-column>
                        <el-table-column align="center" prop="price"></el-table-column>
                        <el-table-column align="center" prop="number"></el-table-column>
                        <el-table-column
                          align="center"
                          show-overflow-tooltip
                        >{{new Date(parseInt(scope.row.create_time) * 1000).toLocaleString().replace(/:\d{1,2}$/,'') }}</el-table-column>
                      </el-table>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="品牌"></el-table-column>
                  <el-table-column align="center" label="货号"></el-table-column>
                  <el-table-column align="center" label="订购人"></el-table-column>
                  <el-table-column align="center" label="单价"></el-table-column>
                  <el-table-column align="center" label="数量"></el-table-column>
                  <el-table-column align="center" label="日期"></el-table-column>
                  <el-table-column align="center" label="订单状态">
                    <template slot-scope="scope">{{scope.row.status1}}</template>
                  </el-table-column>
                </el-table>
              </template>
              <div class="export">
                <span class="export1" @click="export_refuse">导出列表</span>
              </div>
              <div v-if="total>10">
                <el-pagination
                hide-on-single-page
                  background
                  layout="prev, pager, next"
                  :total="total"
                  :page-size="10"
                  @current-change="setPage"
                  style="text-align:center"
                ></el-pagination>
              </div>
            </el-row>
          </div>
        </el-tab-pane>
        <el-tab-pane label="待发货" name="1">
          <div>
            <el-row :gutter="20">
              <el-col :span="7">
                <div class="grid-content bg-purple">
                  <el-input size="mini" placeholder="搜索订购人" v-model="name">
                    <template slot="append">
                      <div style="cursor: pointer" @click="search()">搜索</div>
                    </template>
                  </el-input>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="grid-content bg-purple">
                  <el-select size="mini" v-model="value" placeholder="请选择状态" @change="selectChange">
                    <el-option
                      v-for="item in options"
                      :key="item.vlaue"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </div>
              </el-col>
            </el-row>
            <el-row style="margin-top:-12px">
              <template>
                <el-table
                  v-loading="loading"
                  cell-class-name="tab_class"
                  :header-cell-style="{
                      'background' : 'rgba(245,250,249,1)'
                    }"
                  :data="tableData"
                  border
                  style="width: 100%;margin-top:30px"
                  :span-method="arraySpanMethod"
                >
                  <el-table-column width="180" prop="orderCode" align="center" label="订单号"></el-table-column>
                  <el-table-column align="center" label="商品名称">
                    <template slot-scope="scope">
                      <el-table
                        :data="JSON.parse(tableData[scope.$index].product_list)"
                        :show-header="false"
                        style="width: 100%"
                      >
                        <el-table-column align="center" show-overflow-tooltip prop="title"></el-table-column>
                        <el-table-column align="center" prop="brand"></el-table-column>
                        <el-table-column align="center" prop="item_no"></el-table-column>
                        <el-table-column align="center" prop="scope.children_remark">
                          <el-tooltip effect="light" placement="top-start">
                            <div slot="content" style="width:189px;line-height:20px">
                              <div>
                                <span>订货人:</span>
                                <span>{{scope.row.address.split(';')[1]}}</span>
                              </div>
                              <div>
                                <span>联系方式:</span>
                                <span>{{scope.row.address.split(';')[0]}}</span>
                              </div>
                              <div>
                                <span>收货地址:</span>
                                <span>{{scope.row.address.split(';')[2]}}</span>
                                <span>{{scope.row.address.split(';')[3]}}</span>
                                <span>{{scope.row.address.split(';')[4]}}</span>
                                <span>{{scope.row.address.split(';')[5]}}</span>
                              </div>
                            </div>
                            <span>{{scope.row.children_remark!=''?scope.row.children_remark:scope.row.nickname}}</span>
                          </el-tooltip>
                        </el-table-column>
                        <el-table-column align="center" prop="price"></el-table-column>
                        <el-table-column align="center" prop="number"></el-table-column>
                        <el-table-column
                          align="center"
                          show-overflow-tooltip
                        >{{new Date(parseInt(scope.row.create_time) * 1000).toLocaleString().replace(/:\d{1,2}$/,'') }}</el-table-column>
                      </el-table>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="品牌"></el-table-column>
                  <el-table-column align="center" label="货号"></el-table-column>
                  <el-table-column align="center" label="订购人"></el-table-column>
                  <el-table-column align="center" label="单价"></el-table-column>
                  <el-table-column align="center" label="数量"></el-table-column>
                  <el-table-column align="center" label="日期"></el-table-column>
                  <el-table-column align="center" label="订单状态">
                    <template slot-scope="scope">{{scope.row.status1}}</template>
                  </el-table-column>
                </el-table>
              </template>
              <div class="export">
                <span class="export1" @click="export_refuse">导出列表</span>
              </div>
              <div v-if="total>10">
                <el-pagination
                hide-on-single-page
                  background
                  layout="prev, pager, next"
                  :total="total"
                  :page-size="10"
                  @current-change="setPage"
                  style="text-align:center"
                ></el-pagination>
              </div>
            </el-row>
          </div>
        </el-tab-pane>
        <el-tab-pane label="待收货" name="3">
          <div>
            <el-row :gutter="20">
              <el-col :span="7">
                <div class="grid-content bg-purple">
                  <el-input size="mini" placeholder="搜索订购人" v-model="name">
                    <template slot="append">
                      <div style="cursor: pointer" @click="search()">搜索</div>
                    </template>
                  </el-input>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="grid-content bg-purple">
                  <el-select size="mini" v-model="value" placeholder="请选择状态" @change="selectChange">
                    <el-option
                      v-for="item in options"
                      :key="item.vlaue"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </div>
              </el-col>
            </el-row>
            <el-row style="margin-top:-12px">
              <template>
                <el-table
                  v-loading="loading"
                  cell-class-name="tab_class"
                  :header-cell-style="{
                      'background' : 'rgba(245,250,249,1)'
                    }"
                  :data="tableData"
                  border
                  style="width: 100%;margin-top:30px"
                  :span-method="arraySpanMethod"
                >
                  <el-table-column width="180" prop="orderCode" align="center" label="订单号"></el-table-column>
                  <el-table-column align="center" label="商品名称">
                    <template slot-scope="scope">
                      <el-table
                        :data="JSON.parse(tableData[scope.$index].product_list)"
                        :show-header="false"
                        style="width: 100%"
                      >
                        <el-table-column align="center" show-overflow-tooltip prop="title"></el-table-column>
                        <el-table-column align="center" prop="brand"></el-table-column>
                        <el-table-column align="center" prop="item_no"></el-table-column>
                        <el-table-column align="center" prop="scope.children_remark">
                          <el-tooltip effect="light" placement="top-start">
                            <div slot="content" style="width:189px;line-height:20px">
                              <div>
                                <span>订货人:</span>
                                <span>{{scope.row.address.split(';')[1]}}</span>
                              </div>
                              <div>
                                <span>联系方式:</span>
                                <span>{{scope.row.address.split(';')[0]}}</span>
                              </div>
                              <div>
                                <span>收货地址:</span>
                                <span>{{scope.row.address.split(';')[2]}}</span>
                                <span>{{scope.row.address.split(';')[3]}}</span>
                                <span>{{scope.row.address.split(';')[4]}}</span>
                                <span>{{scope.row.address.split(';')[5]}}</span>
                              </div>
                            </div>
                            <span>{{scope.row.children_remark!=''?scope.row.children_remark:scope.row.nickname}}</span>
                          </el-tooltip>
                        </el-table-column>
                        <el-table-column align="center" prop="price"></el-table-column>
                        <el-table-column align="center" prop="number"></el-table-column>
                        <el-table-column
                          align="center"
                          show-overflow-tooltip
                        >{{new Date(parseInt(scope.row.create_time) * 1000).toLocaleString().replace(/:\d{1,2}$/,'') }}</el-table-column>
                      </el-table>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="品牌"></el-table-column>
                  <el-table-column align="center" label="货号"></el-table-column>
                  <el-table-column align="center" label="订购人"></el-table-column>
                  <el-table-column align="center" label="单价"></el-table-column>
                  <el-table-column align="center" label="数量"></el-table-column>
                  <el-table-column align="center" label="日期"></el-table-column>
                  <el-table-column align="center" label="订单状态">
                    <template slot-scope="scope">{{scope.row.status1}}</template>
                  </el-table-column>
                </el-table>
              </template>
              <div class="export">
                <span class="export1" @click="export_refuse">导出列表</span>
              </div>
              <div v-if="total>10">
                <el-pagination
                hide-on-single-page
                  background
                  layout="prev, pager, next"
                  :total="total"
                  :page-size="10"
                  @current-change="setPage"
                  style="text-align:center"
                ></el-pagination>
              </div>
            </el-row>
          </div>
        </el-tab-pane>
        <el-tab-pane label="待评价" name="4">
          <div>
            <el-row :gutter="20">
              <el-col :span="7">
                <div class="grid-content bg-purple">
                  <el-input size="mini" placeholder="搜索订购人" v-model="name">
                    <template slot="append">
                      <div style="cursor: pointer" @click="search()">搜索</div>
                    </template>
                  </el-input>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="grid-content bg-purple">
                  <el-select size="mini" v-model="value" placeholder="请选择状态" @change="selectChange">
                    <el-option
                      v-for="item in options"
                      :key="item.vlaue"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </div>
              </el-col>
            </el-row>
            <el-row style="margin-top:-12px">
              <template>
                <el-table
                  v-loading="loading"
                  cell-class-name="tab_class"
                  :header-cell-style="{
                      'background' : 'rgba(245,250,249,1)'
                    }"
                  :data="tableData"
                  border
                  style="width: 100%;margin-top:30px"
                  :span-method="arraySpanMethod"
                >
                  <el-table-column width="180" prop="orderCode" align="center" label="订单号"></el-table-column>
                  <el-table-column align="center" label="商品名称">
                    <template slot-scope="scope">
                      <el-table
                        :data="JSON.parse(tableData[scope.$index].product_list)"
                        :show-header="false"
                        style="width: 100%"
                      >
                        <el-table-column align="center" show-overflow-tooltip prop="title"></el-table-column>
                        <el-table-column align="center" prop="brand"></el-table-column>
                        <el-table-column align="center" prop="item_no"></el-table-column>
                        <el-table-column align="center" prop="scope.children_remark">
                          <el-tooltip effect="light" placement="top-start">
                            <div slot="content" style="width:189px;line-height:20px">
                              <div>
                                <span>订货人:</span>
                                <span>{{scope.row.address.split(';')[1]}}</span>
                              </div>
                              <div>
                                <span>联系方式:</span>
                                <span>{{scope.row.address.split(';')[0]}}</span>
                              </div>
                              <div>
                                <span>收货地址:</span>
                                <span>{{scope.row.address.split(';')[2]}}</span>
                                <span>{{scope.row.address.split(';')[3]}}</span>
                                <span>{{scope.row.address.split(';')[4]}}</span>
                                <span>{{scope.row.address.split(';')[5]}}</span>
                              </div>
                            </div>
                            <span>{{scope.row.children_remark!=''?scope.row.children_remark:scope.row.nickname}}</span>
                          </el-tooltip>
                        </el-table-column>
                        <el-table-column align="center" prop="price"></el-table-column>
                        <el-table-column align="center" prop="number"></el-table-column>
                        <el-table-column
                          align="center"
                          show-overflow-tooltip
                        >{{new Date(parseInt(scope.row.create_time) * 1000).toLocaleString().replace(/:\d{1,2}$/,'') }}</el-table-column>
                      </el-table>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="品牌"></el-table-column>
                  <el-table-column align="center" label="货号"></el-table-column>
                  <el-table-column align="center" label="订购人"></el-table-column>
                  <el-table-column align="center" label="单价"></el-table-column>
                  <el-table-column align="center" label="数量"></el-table-column>
                  <el-table-column align="center" label="日期"></el-table-column>
                  <el-table-column align="center" label="订单状态">
                    <template slot-scope="scope">{{scope.row.status1}}</template>
                  </el-table-column>
                </el-table>
              </template>
              <div class="export">
                <span class="export1" @click="export_refuse">导出列表</span>
              </div>
              <div v-if="total>10">
                <el-pagination
                  background
                  hide-on-single-page
                  layout="prev, pager, next"
                  :total="total"
                  :page-size="10"
                  @current-change="setPage"
                  style="text-align:center"
                ></el-pagination>
              </div>
            </el-row>
          </div>
        </el-tab-pane>
        <el-tab-pane v-if="state==1" label="待审批" name="待审批">
          <div v-if="tableData.length!=0">
            <el-row :gutter="20">
              <el-col :span="7">
                <div class="grid-content bg-purple">
                  <el-input size="mini" placeholder="搜索订购人" v-model="name">
                    <template slot="append">
                      <div style="cursor: pointer" @click="search()">搜索</div>
                    </template>
                  </el-input>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="grid-content bg-purple">
                  <el-select size="mini" v-model="value" placeholder="请选择状态" @change="selectChange">
                    <el-option
                      v-for="item in options"
                      :key="item.vlaue"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </div>
              </el-col>
            </el-row>
            <el-row style="margin-top:-12px">
              <template>
                <el-table
                  v-loading="loading"
                  cell-class-name="tab_class"
                  :header-cell-style="{
                      'background' : 'rgba(245,250,249,1)'
                    }"
                  :data="tableData"
                  border
                  style="width: 100%;margin-top:30px"
                  :span-method="arraySpanMethod"
                >
                  <el-table-column width="180" prop="orderCode" align="center" label="订单号"></el-table-column>
                  <el-table-column align="center" label="商品名称">
                    <template slot-scope="scope">
                      <el-table
                        :data="JSON.parse(tableData[scope.$index].product_list)"
                        :show-header="false"
                        style="width: 100%"
                      >
                        <el-table-column align="center" show-overflow-tooltip prop="title"></el-table-column>
                        <el-table-column align="center" prop="brand"></el-table-column>
                        <el-table-column align="center" prop="item_no"></el-table-column>
                        <el-table-column align="center" prop="scope.children_remark">
                          <el-tooltip effect="light" placement="top-start">
                            <div slot="content" style="width:189px;line-height:20px">
                              <div>
                                <span>订货人:</span>
                                <span>{{scope.row.address.split(';')[1]}}</span>
                              </div>
                              <div>
                                <span>联系方式:</span>
                                <span>{{scope.row.address.split(';')[0]}}</span>
                              </div>
                              <div>
                                <span>收货地址:</span>
                                <span>{{scope.row.address.split(';')[2]}}</span>
                                <span>{{scope.row.address.split(';')[3]}}</span>
                                <span>{{scope.row.address.split(';')[4]}}</span>
                                <span>{{scope.row.address.split(';')[5]}}</span>
                              </div>
                            </div>
                            <span>{{scope.row.children_remark!=''?scope.row.children_remark:scope.row.nickname}}</span>
                          </el-tooltip>
                        </el-table-column>
                        <el-table-column align="center" prop="price"></el-table-column>
                        <el-table-column align="center" prop="number"></el-table-column>
                        <el-table-column
                          align="center"
                          show-overflow-tooltip
                        >{{new Date(parseInt(scope.row.create_time) * 1000).toLocaleString().replace(/:\d{1,2}$/,'') }}</el-table-column>
                      </el-table>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="品牌"></el-table-column>
                  <el-table-column align="center" label="货号"></el-table-column>
                  <el-table-column align="center" label="订购人"></el-table-column>
                  <el-table-column align="center" label="单价"></el-table-column>
                  <el-table-column align="center" label="数量"></el-table-column>
                  <el-table-column align="center" label="日期"></el-table-column>
                  <el-table-column align="center" label="审批操作">
                    <template slot-scope="scope">
                      <div style="text-align:right">
                        <button class="btn" @click="audit(scope.row.orderCode,1)">通过</button>
                      </div>
                      <div style="text-align:left">
                        <button class="btn" @click="audit(scope.row.orderCode,2)">拒绝</button>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </template>
              <div class="export">
                <span class="export1" @click="export_refuse">导出列表</span>
              </div>
              <div v-if="total>10">
                <el-pagination
                  background
                  hide-on-single-page
                  layout="prev, pager, next"
                  :total="total"
                  :page-size="10"
                  @current-change="setPage"
                  style="text-align:center"
                ></el-pagination>
              </div>
            </el-row>
          </div>
          <div style="margin: 0 auto;width:500px;height:334px" v-if="tableData.length==0">
            <img :src="serve + '/image/none/order.jpg'" alt />
          </div>
        </el-tab-pane>
        <el-tab-pane v-if="state==1" label="已拒绝订单" name="已拒绝订单">
          <div v-if="tableData.length!=0">
            <el-row :gutter="20">
              <el-col :span="7">
                <div class="grid-content bg-purple">
                  <el-input size="mini" placeholder="搜索订购人" v-model="name">
                    <template slot="append">
                      <div style="cursor: pointer" @click="search()">搜索</div>
                    </template>
                  </el-input>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="grid-content bg-purple">
                  <el-select size="mini" v-model="value" placeholder="请选择状态" @change="selectChange">
                    <el-option
                      v-for="item in options"
                      :key="item.vlaue"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </div>
              </el-col>
            </el-row>
            <el-row style="margin-top:-12px">
              <template>
                <el-table
                  cell-class-name="tab_class"
                  v-loading="loading"
                  :header-cell-style="{
                      'background' : 'rgba(245,250,249,1)'
                    }"
                  :data="tableData"
                  border
                  style="width: 100%;margin-top:30px"
                  :span-method="arraySpanMethod"
                >
                  <el-table-column width="180" prop="orderCode" align="center" label="订单号"></el-table-column>
                  <el-table-column align="center" label="商品名称">
                    <template slot-scope="scope">
                      <el-table
                        :data="JSON.parse(tableData[scope.$index].product_list)"
                        :show-header="false"
                        style="width: 100%"
                      >
                        <el-table-column align="center" show-overflow-tooltip prop="title"></el-table-column>
                        <el-table-column align="center" prop="brand"></el-table-column>
                        <el-table-column align="center" prop="item_no"></el-table-column>
                        <el-table-column align="center" prop="scope.children_remark">
                          <el-tooltip effect="light" placement="top-start">
                            <div slot="content" style="width:189px;line-height:20px">
                              <div>
                                <span>订货人:</span>
                                <span>{{scope.row.address.split(';')[1]}}</span>
                              </div>
                              <div>
                                <span>联系方式:</span>
                                <span>{{scope.row.address.split(';')[0]}}</span>
                              </div>
                              <div>
                                <span>收货地址:</span>
                                <span>{{scope.row.address.split(';')[2]}}</span>
                                <span>{{scope.row.address.split(';')[3]}}</span>
                                <span>{{scope.row.address.split(';')[4]}}</span>
                                <span>{{scope.row.address.split(';')[5]}}</span>
                              </div>
                            </div>
                            <span>{{scope.row.children_remark!=''?scope.row.children_remark:scope.row.nickname}}</span>
                          </el-tooltip>
                        </el-table-column>
                        <el-table-column align="center" prop="price"></el-table-column>
                        <el-table-column align="center" prop="number"></el-table-column>
                        <el-table-column
                          align="center"
                          show-overflow-tooltip
                        >{{new Date(parseInt(scope.row.create_time) * 1000).toLocaleString().replace(/:\d{1,2}$/,'') }}</el-table-column>
                      </el-table>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="品牌"></el-table-column>
                  <el-table-column align="center" label="货号"></el-table-column>
                  <el-table-column align="center" label="订购人"></el-table-column>
                  <el-table-column align="center" label="单价"></el-table-column>
                  <el-table-column align="center" label="数量"></el-table-column>
                  <el-table-column align="center" label="日期"></el-table-column>
                  <el-table-column align="center" label="审批操作">
                    <template slot-scope="scope">
                      <div>{{scope.row.host_check == '2'? '已拒绝' : ''}}</div>
                    </template>
                  </el-table-column>
                </el-table>
              </template>
              <div class="export">
                <span class="export1" @click="export_refuse">导出列表</span>
              </div>
              <div v-if="total>10">
                <el-pagination
                  background
                  hide-on-single-page
                  layout="prev, pager, next"
                  :total="total"
                  :page-size="10"
                  @current-change="setPage"
                  style="text-align:center"
                ></el-pagination>
              </div>
            </el-row>
          </div>
          <div style="margin: 0 auto;width:500px;height:334px" v-if="tableData.length==0">
            <img :src="serve + '/image/none/order.jpg'" alt />
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      serve: this.$store.state.serve,

      options: [
        {
          value: "0",
          label: "待付款"
        },
        {
          value: "1",
          label: "待采购"
        },
        {
          value: "2",
          label: "待发货"
        },
        {
          value: "3",
          label: "待收货"
        },
        {
          value: "4",
          label: "待评价"
        },
        {
          value: "5",
          label: "已完成"
        },
        {
          value: "6",
          label: "已取消"
        },
        {
          value: "7",
          label: "待开票"
        },
        {
          value: "8",
          label: "待报销"
        }
      ],
      value: "",
      tableData: [],
      chlidren_order: [],
      mobile: this.$cookies.get("user"),
      token: this.$cookies.get("token"),
      page: null,
      total: null,
      name: "",
      state: null,
      tab: "all",
      tab_status: null,
      loading: false,
      show_img: false,
      status: null
    };
  },
  activated() {
    this.$store.state.user_location = "我的订单";
  },
  created() {
    this.axios
      .get(this.serve + "/personal/is_open_host", {
        params: {
          mobile: this.$cookies.get("user"),
          token: this.$cookies.get("token")
        }
      })
      .then(res => {
        if (res.data == 1) {
          this.state = 1;
        } else if (res.data == 0) {
          this.state = 0;
        }
      });
    this.geting();
  },
  methods: {
    download() {},
    export_refuse() {
      this.loading = true;
      // const loading = this.$loading({
      //   lock: true,
      //   text: "Loading",
      //   spinner: "el-icon-loading",
      //   background: "rgba(0, 0, 0, 0.7)"
      // });
      var where = {
        token: this.token,
        mobile: this.mobile,
        name: this.name,
        status: this.status,
        check_status: this.tab_status
      };
      this.axios
        .get(this.serve + "/personal/download_children_order", {
          params: where,
          responseType: "blob",
          onDownloadProgress: function(progressEvent) {}
        })
        .then(res => {
          if (res.data.type == "text/html") {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            let fileName = "宝枫林订单详情列表.xlsx";
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();

            this.loading = false;
            this.$message({
              type: "success",
              message: "操作成功",
              offset: 200
            });
          } else {
            this.$message({
              showClose: true,
              message: "导出失败请重新操作",
              type: "error",
              offset: 200
            });
          }
        })
        .catch(er => {
          this.loading = false;
          this.$message({
            showClose: true,
            message: "导出失败请重新操作",
            type: "error",
            offset: 200
          });
        });
    },
    audit(order, sta) {
      // this.loading = true
      this.$confirm("此操作将审批该订单, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.axios
          .get(this.serve + "/personal/check_order", {
            params: {
              mobile: this.mobile,
              token: this.token,
              orderCode: order,
              check_res: sta
            }
          })
          .then(res => {
            if (res.data.status == "success") {
              // this.loading = false
              this.geting();
              if (sta == 1) {
                this.$message({
                  type: "success",
                  message: res.data.msg
                });
              }
              if (sta == 2) {
                this.alert_refuse();
              }
            }
          });
      });
      // .catch(() => {
      //   this.$message({
      //     type: "info",
      //     message: "已取消删除"
      //   });
      // });
    },
    handleClick(tab, event) {
      console.log(tab.name);
      if (tab.name == "all") {
        this.status = null;
        this.geting();
      } else if (tab.name == "0") {
        this.status = 0;
        this.geting();
      } else if (tab.name == "1") {
        this.status = 1;
        this.geting();
      } else if (tab.name == "3") {
        this.status = 3;
        this.geting();
      } else if (tab.name == "4") {
        this.status = 4;
        this.geting();
      } else if (tab.name == "待审批") {
        this.tab_status = 0;
        this.geting();
      } else if (tab.name == "已拒绝订单") {
        this.tab_status = 2;
        this.geting();
      }
    },
    selectChange(e) {
      this.status = e;
      this.geting();
    },
    search() {
      this.geting();
    },
    setPage(v) {
      this.geting(v);
    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 1) {
        return [1, 7];
      } else if (columnIndex > 1 && columnIndex <= 7) {
        return [0, 0];
      }
    },
    alert_refuse() {
      this.$message({
        customClass: "new_alert",
        type: "none",
        duration: 2000,
        dangerouslyUseHTMLString: true,
        offset: 400,
        message:
          '<div style="line-height:25px;width:234px;height:50px;font-size:18px;font-family:Microsoft YaHei;font-weight:400;color:rgba(51,51,51,1);">您已拒绝一项审批申请,可以到已拒绝订单查看</div>'
      });
    },
    geting(v) {
      this.loading = true;
      var where = {
        token: this.token,
        mobile: this.mobile,
        page: v,
        status: this.status,
        check_status: this.tab_status
      };
      // if(this.tab_status==''){
      // where.status = this.status,

      // }
      this.axios
        .get(this.serve + "/personal/new_order_list", {
          params: where
        })
        .then(res => {
          console.log(res);
          //   return
          this.tableData = [];
          var json = res.data.data;
          if (res.data.status == "success") {
            this.show_img = true;
            this.loading = false;
            this.tableData = json.results;
            this.page = json.page;
            this.total = json.total;
            for (var i in json.results) {
              if (json.results[i].status == 0) {
                json.results[i].status1 = "待付款";
              } else if (json.results[i].status == 1) {
                json.results[i].status1 = "待采购";
              } else if (json.results[i].status == 2) {
                json.results[i].status1 = "待发货";
              } else if (json.results[i].status == 3) {
                json.results[i].status1 = "待收货";
              } else if (json.results[i].status == 4) {
                json.results[i].status1 = "待评价";
              } else if (json.results[i].status == 5) {
                json.results[i].status1 = "已完成";
              } else if (json.results[i].status == 6) {
                json.results[i].status1 = "已取消";
              } else if (json.results[i].status == 7) {
                json.results[i].status1 = "待开票";
              } else if (json.results[i].status == 8) {
                json.results[i].status1 = "待报销";
              }
            }
          } else {
            this.show_img = true;
            this.loading = false;
          }
        });
    }
  }
};
</script>
<style lang="scss">
#children_order {
  .r1 {
    padding: 5px;
    margin-right: 10px;
    cursor: pointer;
    position: relative;
    top: 8px;
    //   margin-bottom: -26px;
    z-index: 10;
    display: inline-block;
    float: right;
  }
  .r1:hover {
    color: #e2211c;
  }
  .tab_class {
    padding: 0 !important;
  }
  .new_alert {
    display: flex;
    justify-content: center;
    width: 351px;
    height: 108px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
    border-radius: 4px;
  }
  .el-tabs__content {
    min-height: 600px;
  }
  .btn {
    // border: 0;
    padding-left: 18px;
    padding-right: 18px;
    border: none;
    outline: none;
    background: none;
    font-size: 14px;
    font-family: "MicrosoftYaHeiLight";
    font-weight: 300;
    color: rgba(51, 51, 51, 1);
    line-height: 18px;
    cursor: pointer;
  }
  .btn:hover {
    color: #e2211c;
  }
  // .chlid_div{
  //   width: 100%;
  //   height: 50px;
  //   border-bottom: 1px solid #ebeef5;
  // }
  .export {
    margin-top: 20px;
    text-align: right;
    // min-height: 500px;
  }
  .export1 {
    font-size: 14px;
    font-family: "Microsoft YaHei";
    font-weight: 400;
    color: rgba(102, 102, 102, 1);
    cursor: pointer;
  }
  .export1:hover {
    color: #e2211c;
  }
  .el-tabs--border-card > .el-tabs__header .el-tabs__item {
    border-top: 3px solid #f5f7fa;
  }
  .el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
    border-top: 3px solid #e2211c;
  }
  .cell {
    padding: 0;
  }

  // .el-table__row > td {
  // padding: 0;
  // }
  .el-table_1_column_2 .is-center .el-tabs__content {
    min-height: 800px;
  }
  .submitclass {
    cursor: pointer;
  }
  .submitclass:hover {
    color: #e2211c;
  }
  .t1 {
    padding: 10px 0;
  }
  .t2 {
    padding: 20px 0;
    text-align: center;
  }
}
</style>